/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1024px){.my-content[_ngcontent-%COMP%]{padding:0;height:545px}.my-content[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]{margin-top:2.5rem;margin-bottom:0}.my-content[_ngcontent-%COMP%]   .divider[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{top:-5px;line-height:30px;width:30px;height:30px;border-radius:50%}}@media (max-width:1024px){.my-content[_ngcontent-%COMP%]{margin:0 auto}}@media (max-width:599px){.my-content[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };
